module.exports = __webpack_public_path__ + "static/img/loginlogo.b5787016.png";